import { fromEvent, } from 'rxjs';
import { distinctUntilChanged, filter, } from 'rxjs/operators';
import * as i0 from "@angular/core";
var StorageService = /** @class */ (function () {
    function StorageService() {
    }
    Object.defineProperty(StorageService.prototype, "keys", {
        get: function () {
            var result = [];
            for (var i = 0; i < localStorage.length; i++) {
                result.push(localStorage.key(i));
            }
            return result;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StorageService.prototype, "isEmpty", {
        get: function () {
            return this.keys.length === 0;
        },
        enumerable: true,
        configurable: true
    });
    StorageService.prototype.remove = function (key) {
        if (typeof key === 'string') {
            localStorage.removeItem(key);
        }
        else if (key instanceof Array) {
            for (var i = 0; i < key.length; i++) {
                if (typeof key[i] === 'string') {
                    localStorage.removeItem(key[i]);
                }
                else {
                    throw new Error('Key in index ' + i + ' is not a string');
                }
            }
        }
        else {
            throw new Error('Key must be a string or array for function remove(key || array)');
        }
    };
    StorageService.prototype.get = function (key, defaultValue) {
        if (typeof key !== 'string') {
            throw new Error('Key must be a string for function get(key)');
        }
        var value = localStorage.getItem(key); // retrieve value
        var number = parseFloat(value); // to allow for number checking
        if (value === null ||
            value === 'null') {
            // Returns default value if key is not set, otherwise returns null
            return defaultValue != null ? defaultValue : null;
        }
        if (!isNaN(number)) {
            return number; // value was of type number
        }
        if (value.toLowerCase() === 'true' || value.toLowerCase() === 'false') {
            return value === 'true'; // value was of type boolean
        }
        try {
            value = JSON.parse(value);
            return value;
        }
        catch (e) {
            return value;
        }
    };
    StorageService.prototype.set = function (key, value) {
        if (typeof key === 'string') {
            if (value == null) {
                this.remove(key);
                return;
            }
            if (typeof value === 'object') {
                value = JSON.stringify(value);
            }
            localStorage.setItem(key, value);
        }
        else {
            throw new Error('Invalid arguments for function set(key, value) or function set(object)');
        }
    };
    StorageService.prototype.store = function (value) {
        if (typeof value === 'object' && !(value instanceof Array)) {
            for (var property in value) {
                if (value.hasOwnProperty(property)) {
                    this.set(property, value[property]);
                }
            }
        }
        else {
            throw new Error('Argument for function set(object) must be an object');
        }
    };
    StorageService.prototype.contains = function (key) {
        if (typeof key !== 'string') {
            throw new Error('Key must be a string for function contains(key)');
        }
        return this.keys.indexOf(key) !== -1;
    };
    StorageService.prototype.clear = function () {
        localStorage.clear();
    };
    StorageService.prototype.watch = function (property) {
        return fromEvent(window, 'storage').pipe(filter(function (e) { return e.key === property || !property; }), 
        // IE spams localStorage events like crazy ;(
        distinctUntilChanged(function (a, b) { return a.newValue === b.newValue; }));
    };
    StorageService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function StorageService_Factory() { return new StorageService(); }, token: StorageService, providedIn: "root" });
    return StorageService;
}());
export { StorageService };
